export const faqCategories = {
	init: function() {
		this.faqCategoriesContainer = document.querySelector('.faq-info');
		if (!this.faqCategoriesContainer) return;
		this.footer = document.querySelector('.footer');
		this.faqOffset = this.faqCategoriesContainer.getBoundingClientRect().top;
		this.assignEventListener();
	},

	assignEventListener: function() {
		window.addEventListener('scroll', _=> {
			this.checkOffset();
		});

		window.addEventListener('resize', _=> {
			this.faqOffset = this.faqCategoriesContainer.getBoundingClientRect().top;
			this.faqCategoriesContainer.classList.remove('reachBottom');
		});
	},

	checkOffset: function() {
		const faqNewOffset = this.faqCategoriesContainer.getBoundingClientRect().top,
			  faqHeight = this.faqCategoriesContainer.offsetHeight,
			  footerOffset = this.footer.getBoundingClientRect().top;
		if (this.faqOffset + faqHeight >= footerOffset) {
			this.faqCategoriesContainer.classList.add('reachBottom');
		}
		if (this.faqOffset + 10 < faqNewOffset) {
			this.faqCategoriesContainer.classList.remove('reachBottom');
		}
	}
}
